import NewTabLink from '@components/utils/links/newTabLink';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import { AdditionalProductFragment } from '@graphql/generated/graphql';

type PropsType = {
    children: React.ReactNode;
    additionalProduct: AdditionalProductFragment;
};

export const AdditionalProductBannerWrapper = ({
    children,
    additionalProduct,
}: PropsType) => {
    if (!additionalProduct.Url) return null;

    return (
        <NewTabLink
            href={additionalProduct.Url}
            destination_name={additionalProduct.Name}
            destination_category={
                OutboundLinkDestinationCategory.AdditionalProduct
            }
            context={OutboundLinkContext.StoryPage}
            shape={OutboundLinkShape.Banner}
        >
            {children}
        </NewTabLink>
    );
};
